import { createFileRoute } from "@tanstack/react-router";
import SaintTmsCostEs from "@/pages/es/SaintTmsCostEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/saint-tms-cost`;

export const Route = createFileRoute("/es/saint-tms-cost")({
  head: () => ({
    meta: [
      { title: "¿Cuánto cuesta SAINT TMS? | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Cuánto cuesta la terapia SAINT TMS, qué cubre típicamente el seguro y cómo se compara el protocolo de 5 días con un curso de seis semanas de TMS estándar.",
      },
      {
        property: "og:title",
        content: "¿Cuánto cuesta SAINT TMS? | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "Cuánto cuesta SAINT TMS, qué cubre el seguro y cómo se compara el protocolo de 5 días con la TMS estándar.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "¿Cuánto cuesta SAINT TMS? | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "Cuánto cuesta SAINT TMS, qué cubre el seguro y cómo se compara el protocolo de 5 días con la TMS estándar.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/saint-tms-cost"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintTmsCostEs />;
}
